module.exports = __webpack_public_path__ + "cement/img/组 4419@2x.6009952d.png";